import { isRouteErrorResponse, useRouteError } from 'react-router';
import StepBar from '../components/StepBar';
import { signInUrl } from '../lib/supabase';

export default function RouteError() {
  const error = useRouteError();

  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error && /fetch|network|offline|failed to load|timeout/i.test(error.message)
      ? 'The studio is unreachable'
      : 'That link did not work';

  const detail = isRouteErrorResponse(error)
    ? String(error.data || '')
    : error instanceof Error
      ? error.message
      : 'Unexpected application error';

  return (
    <main className="shell">
      <div className="card">
        <div className="tick err" aria-hidden="true">
          !
        </div>
        <StepBar left="Not signed in" right="Nothing lost" />
        <h1 className="d">{title}</h1>
        <p className="sub">{detail}</p>
        <div className="rule" />
        <div className="actions">
          <a className="btn" href={signInUrl(true)}>
            Start again →
          </a>
        </div>
      </div>
    </main>
  );
}
